<template>
  <div class="container">
    <el-form :inline="true">
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #nick_name="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="row.phone"
          placement="top"
        >
          <div>{{ row.nick_name }}<i class="el-icon-phone"></i></div>
        </el-tooltip>
      </template>
      <template #handler="{ row }">
        <div>
          <el-button v-if="row.status == 1" type="primary" size="small" @click="confirm(row)"
            >确认到店</el-button
          >
        </div>
      </template>
    </auto-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      DataList: [],
      Option: [
        { name: "名称", value: "nick_name", type: "custom" },
        { name: "订单", value: "order_no" },
        { name: "课程", value: "course_name" },
        { name: "状态", value: "status_name" },
        { name: "佣金", value: "per_user_commission" },
        { name: "购买时间", value: "invited_at" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      status: 1,
      load: false,
      manager: JSON.parse( localStorage.getItem("managerInfo")),
    };
  },

  mounted() {
    this.id = this.$route.query.id;
  },

  methods: {
    confirm(row) {
      this.$confirm("确认学员已经到店体验，确认后将结算佣金给招生人。").then(
        () => {
          this.$post("/user/enrollDemands/confArr", {
            id: row.id,
            verified_by: this.manager.id,
          }).then((res) => {
            this.getList(1);
          });
        }
      );
    },

    openGeo(row) {
      this.$refs.amap.open(row);
    },
    init() {
      if (!this.load) {
        this.load = true;
        this.getList(1);
      }
    },
    openAdd() {
      let comm = { venue_id: this.id };
      this.$refs.add.open(comm);
    },
    openEdit(row) {
      this.$refs.add.open(row);
    },

    //获取列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/enrollInvite/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          demand_id: this.id,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>